(function () {
  'use strict';

  /* Last-known-good plan id from Stay's own widget. null = one-time purchase selected. */
  var stayLastSellingPlanId = null;

  window.addEventListener('stay-ai-subscription-changed', function (e) {
    stayLastSellingPlanId = e.detail.sellingPlanId || null;
  });

  /* @stayai: cart guard — forces /cart/add's selling_plan to Stay's value, backstops the DISABLE_RECHARGE kill switch */
  var originalFetch = window.fetch;
  window.fetch = function (input, init) {
    try {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      if (init && init.body instanceof FormData && /\/cart\/add(\.js)?(\?|$)/.test(url)) {
        var fd = init.body;
        fd.delete('selling_plan');
        if (stayLastSellingPlanId) {
          fd.set('selling_plan', stayLastSellingPlanId);
        }
      }
    } catch (err) {
      console.error('stayai-pdp cart guard error:', err);
    }
    return originalFetch.apply(this, arguments);
  };
})();
